module.exports = __webpack_public_path__ + "static/media/Жабко А., Гапонов Д. (ММ).cfbaaa49.pdf";